import { useKeenSlider } from 'keen-slider/react';
import { createAutoSlidePlugin } from '@/views/build/util/createAutoSlidePlugin';
import { FILE_TYPE_IMAGES } from './fileTypeImages';

// 애니메이션에 사용할 파일 타입 이미지 정의
const fileTypeImages = [{
  src: FILE_TYPE_IMAGES.pdf,
  alt: 'PDF',
  key: 'pdf'
}, {
  src: FILE_TYPE_IMAGES.docx,
  alt: 'DOCX',
  key: 'docx'
}, {
  src: FILE_TYPE_IMAGES.pptx,
  alt: 'PPTX',
  key: 'pptx'
}, {
  src: FILE_TYPE_IMAGES.hwp,
  alt: 'HWP',
  key: 'hwp'
}, {
  src: FILE_TYPE_IMAGES.txt,
  alt: 'TXT',
  key: 'txt'
}, {
  src: FILE_TYPE_IMAGES.csv,
  alt: 'CSV',
  key: 'csv'
}];
const ICON_SIZE = 20; // Figma 디자인 명세에 맞춘 20px

// 200ms 초기 딜레이 후 800ms마다 슬라이드 (Figma 명세)
const autoSlide = createAutoSlidePlugin({
  intervalMs: 800
});

/**
 * 버튼에서 사용할 수직 롤링 파일 타입 아이콘 애니메이션을 렌더링합니다.
 * 6개의 파일 타입 아이콘을 순환하며 무한 반복합니다.
 */
export const RollingFileIcons = () => {
  const [sliderRef] = useKeenSlider({
    loop: true,
    vertical: true,
    slides: {
      perView: 1
    },
    renderMode: 'performance'
  }, [autoSlide]);
  return <div ref={sliderRef} className="size-[20px] overflow-hidden" data-sentry-component="RollingFileIcons" data-sentry-source-file="RollingFileIcons.tsx">
      {fileTypeImages.map(item => <div key={item.key} className="keen-slider__slide flex items-center justify-center">
          <img src={item.src} alt={item.alt} width={ICON_SIZE} height={ICON_SIZE} className="object-contain" />
        </div>)}
    </div>;
};